// extracted by mini-css-extract-plugin
module.exports = {"form-item":"styles__form-item__fx3i4","formItem":"styles__form-item__fx3i4","required-icon":"styles__required-icon__1N-hO","requiredIcon":"styles__required-icon__1N-hO"};